export const isAndroid = /android/i.test(window.navigator.userAgent);
export const isApple = /iP(hone|od|ad)/i.test(window.navigator.userAgent);
export const isIE = /MSIE|Trident/i.test(window.navigator.userAgent);
export const devicePixelRatio = (() => {
  return window.devicePixelRatio !== undefined ? window.devicePixelRatio : 1;
})();
export const isRetina = (() => {
  return devicePixelRatio > 1;
})();
export const supportsSrcdoc = 'srcdoc' in document.createElement('iframe');

export const isInIframe = window.self !== window.top;

export const scrollBarWidth = (() => {
  const scrollDiv = document.createElement('div');

  Object.assign(scrollDiv.style, {
    width: '100px',
    height: '100px',
    overflow: 'scroll',
    position: 'absolute',
    top: '-9999px',
  });
  document.body.appendChild(scrollDiv);

  const ourScrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);
  return ourScrollBarWidth;
})();
